var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "titles",
      attrs: {
        inline: true,
        model: _vm.application.titles.titleConsideration,
        "label-width": "150px",
        disabled: true,
        size: "small"
      }
    },
    [
      _c("el-form-item", { attrs: { label: "Τύπος Φοίτησης" } }, [
        _vm._v(_vm._s(_vm.distant))
      ]),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.distant === "Συμβατικός",
              expression: "distant === 'Συμβατικός'"
            }
          ],
          attrs: { label: "Μερική" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.application.titles.titleConsideration.partTime ? "Ναι" : "Όχι"
            )
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.distant === "Εξ αποστάσεως",
              expression: "distant === 'Εξ αποστάσεως'"
            }
          ]
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c("el-checkbox", {
                attrs: {
                  label: "Μέρος έγινε στην Ελλάδα",
                  name: "application.titles.titleConsideration.partOfStudiesGr"
                },
                model: {
                  value:
                    _vm.application.titles.titleConsideration.partOfStudiesGr,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.application.titles.titleConsideration,
                      "partOfStudiesGr",
                      $$v
                    )
                  },
                  expression:
                    "application.titles.titleConsideration.partOfStudiesGr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.application.titles.titleConsideration.partOfStudiesGr,
                  expression:
                    "application.titles.titleConsideration.partOfStudiesGr"
                }
              ],
              attrs: { label: "Πόλη" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.application.titles.titleConsideration.cityOfStudiesGr
                )
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.application.titles.titleConsideration.partOfStudiesGr,
                  expression:
                    "application.titles.titleConsideration.partOfStudiesGr"
                }
              ],
              attrs: { label: "Ίδρυμα" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.application.titles.titleConsideration
                    .institutionOfStudiesGr
                )
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.application.degreeType === "master",
              expression: "application.degreeType === 'master'"
            }
          ]
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value:
                      _vm.application.titles.titleConsideration.greekBachelor,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.application.titles.titleConsideration,
                        "greekBachelor",
                        $$v
                      )
                    },
                    expression:
                      "application.titles.titleConsideration.greekBachelor"
                  }
                },
                [_vm._v("Ελληνικό Βασικό Πτυχίο")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.application.titles.titleConsideration.greekBachelor,
                  expression:
                    "application.titles.titleConsideration.greekBachelor"
                }
              ],
              attrs: { label: "Τμήμα" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.application.titles.titleConsideration
                    .greekBachelorInserted
                )
              )
            ]
          )
        ],
        1
      ),
      _c("hr"),
      _vm.countryExists
        ? _c("el-form-item", { attrs: { label: "Χώρα Σπουδών" } }, [
            _vm._v(
              _vm._s(_vm.application.titles.titleConsideration.country.name)
            )
          ])
        : _vm._e(),
      _vm.application.titles.titleConsideration.country.name === "other"
        ? _c("el-form-item", { attrs: { label: "Χώρα Σπουδών" } }, [
            _vm._v(
              _vm._s(
                _vm.application.titles.titleConsideration.country
                  .countryInserted
              )
            ),
            _c("div", { staticStyle: { color: "red" } }, [
              _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝH Χώρα")
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        [
          _vm.universityExists
            ? _c(
                "el-form-item",
                { attrs: { label: "Πανεπιστήμιο" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.application.titles.titleConsideration.university.name
                    )
                  ),
                  _vm.omotagesUniversity === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το ίδρυμα είναι ομοταγές",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesUniversity === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το ίδρυμα δεν είναι ομοταγές",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesUniversity === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν ίδρυμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesUniversity === "No data found for University."
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title:
                            "Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.titleConsideration.university.name === "other"
            ? _c("el-form-item", { attrs: { label: "Πανεπιστήμιο" } }, [
                _vm._v(
                  _vm._s(
                    _vm.application.titles.titleConsideration.university
                      .universityInserted
                  )
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Πανεπιστήμιο")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.collegeExists
            ? _c(
                "el-form-item",
                { attrs: { label: "Κολλέγιο" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.application.titles.titleConsideration.college.name
                    )
                  ),
                  _vm.omotagesCollege === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το κολέγιο είναι αναγνωρισμένο",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesCollege === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το κολέγιο δεν είναι αναγνωρισμένο",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesCollege === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν κολέγιο",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.titleConsideration.college.name === "other"
            ? _c("el-form-item", { attrs: { label: "Κολλέγιο" } }, [
                _vm._v(
                  _vm._s(
                    _vm.application.titles.titleConsideration.college
                      .collegeInserted
                  )
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Κολλέγιο")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.facultyExists
            ? _c(
                "el-form-item",
                { attrs: { label: "Σχολή" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.application.titles.titleConsideration.faculty.name
                    )
                  ),
                  _vm.omotagesFaculty === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Η σχολή είναι αναγνωρισμένη",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesFaculty === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Η σχολή δεν είναι αναγνωρισμένη",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesFaculty === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθείσα σχολή",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.titleConsideration.faculty.name === "other"
            ? _c("el-form-item", { attrs: { label: "Σχολή" } }, [
                _vm._v(
                  _vm._s(
                    _vm.application.titles.titleConsideration.faculty
                      .facultyInserted
                  )
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΗ ΣΧΟΛΗ")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.departmentExists
            ? _c(
                "el-form-item",
                { attrs: { label: "Τμήμα" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.application.titles.titleConsideration.department.name
                    )
                  ),
                  _vm.omotagesDepartment === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το τμήμα είναι αναγνωρισμένο",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesDepartment === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το τμήμα δεν είναι αναγνωρισμένο",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotagesDepartment === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν τμήμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.titleConsideration.department.name === "other"
            ? _c("el-form-item", { attrs: { label: "Τμήμα" } }, [
                _vm._v(
                  _vm._s(
                    _vm.application.titles.titleConsideration.department
                      .departmentInserted
                  )
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Τμήμα")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c("hr"),
      _c(
        "el-form-item",
        {
          staticClass: "compact-form-item",
          attrs: { label: "Τίτλος Σπουδών (όπως υποβλήθηκε)" }
        },
        [
          _vm._v(
            _vm._s(_vm.application.titles.titleConsideration.certificationTitle)
          )
        ]
      ),
      _c(
        "div",
        [
          _c("el-form-item", { attrs: { label: "Πιστωτικές Μονάδες" } }, [
            _vm._v(_vm._s(_vm.application.titles.titleConsideration.credits))
          ]),
          _c("el-form-item", { attrs: { label: "Διάρκεια Σπουδών" } }, [
            _vm._v(
              _vm._s(
                _vm.application.titles.titleConsideration.durationOfStudies
              )
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c("el-form-item", { attrs: { label: "Ημέρ. Εγγραφής" } }, [
            _vm._v(
              _vm._s(
                _vm.application.titles.titleConsideration.dateOfRegistration
              )
            )
          ]),
          _c("el-form-item", { attrs: { label: "Ημερ. Αποφοίτησης" } }, [
            _vm._v(
              _vm._s(_vm.application.titles.titleConsideration.dateOfGraduation)
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-form-item",
            {
              staticClass: "certification-title",
              attrs: { label: "Τίτλος Σπουδών" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.application.considerationTitleByInternal ||
                    _vm.application.titles.titleConsideration.certificationTitle
                )
              )
            ]
          )
        ],
        1
      ),
      _c("hr"),
      _c(
        "el-form-item",
        { attrs: { label: "Οι σπουδές έγιναν" } },
        [
          _c("el-switch", {
            attrs: {
              "active-text": "σε περισσότερα Πανεπιστήμια",
              "inactive-text": "σε ένα Πανεπιστήμιο"
            },
            model: {
              value:
                _vm.application.titles.titleConsideration
                  .studiesInMoreUniversities,
              callback: function($$v) {
                _vm.$set(
                  _vm.application.titles.titleConsideration,
                  "studiesInMoreUniversities",
                  $$v
                )
              },
              expression:
                "application.titles.titleConsideration.studiesInMoreUniversities"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.application.titles.titleConsideration
                  .studiesInMoreUniversities,
              expression:
                "application.titles.titleConsideration.studiesInMoreUniversities"
            }
          ]
        },
        _vm._l(
          _vm.application.titles.titleConsideration.additionalUniversities,
          function(additionalUni, index) {
            return _c(
              "div",
              [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: additionalUni.university != null,
                        expression: "additionalUni.university != null"
                      }
                    ],
                    attrs: { label: "Πανεπιστήμιο" }
                  },
                  [_vm._v(_vm._s(additionalUni.university))]
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: additionalUni.credits != null,
                        expression: "additionalUni.credits != null"
                      }
                    ],
                    attrs: { label: "Μονάδες" }
                  },
                  [_vm._v(_vm._s(additionalUni.credits))]
                )
              ],
              1
            )
          }
        )
      ),
      _c("hr")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ea95a56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea95a56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TitleConsideration.vue
// module id = null
// module chunks = 